export default __webpack_public_path__ + "7176a5b37a6279026d2627415cd5d932.png";